module.exports = __webpack_public_path__ + "img/SpaceExploration&Research.e1091f40.png";